export const IDENTITY_VERIFICATION_PHRASES: Record<string, number> = {
    VERIFICATION_TITLE: 1507,
    YOTI_NOTES: 18841,
    VERIFICATION_PENDING: 18821,
    RETURN_BACK: 3477,
    BACK_TO_ACCOUNT: 18818,
    TO_PROCEED_WITH_VERIFICATION: 18844,
    CONTINUE_VERIFICATION: 18846,
    OR: 3460,
    PHONE_VERIFICATION: 18845,
    COMPLETE_ON_MOBILE: 10692,
    CANCEL_MOBILE_VERIFICATION: 18843,
    MOBILE_VERIFICATION_IN_PROGRESS: 18842,
    FAILED_VERIFICATION: 18849,
    TRY_AGAIN: 4703,
    YOU_CAN_UPLOAD_DOCS: 18850,
    UPLOAD_DOCUMENTS: 18851,
    VERIFICATION_SUCCESSFUL: 18852,
    SESSION_EXPIRED: 18732,
} as const;
